import { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const GiveawayIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g id="Giveaway Icon">
      <g id="Artboard 4">
        <g id="126">
          <path
            id="Oval 62"
            d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
            stroke="#00AED9"
            strokeWidth="2"
          />
          <path
            id="Path 46"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.12436 3C8.94882 3 8.77637 3.04621 8.62436 3.13397L5.37564 5.00962C5.22362 5.09739 5.09739 5.22363 5.00962 5.37564L3.13397 8.62436C3.04621 8.77637 3 8.94882 3 9.12436V12.8756C3 13.0512 3.04621 13.2236 3.13397 13.3756L5.00962 16.6244C5.09739 16.7764 5.22363 16.9026 5.37564 16.9904L8.62436 18.866C8.77637 18.9538 8.94882 19 9.12436 19H12.8756C13.0512 19 13.2236 18.9538 13.3756 18.866L16.6244 16.9904C16.7764 16.9026 16.9026 16.7764 16.9904 16.6244L18.866 13.3756C18.9538 13.2236 19 13.0512 19 12.8756V9.12436C19 8.94882 18.9538 8.77637 18.866 8.62436L16.9904 5.37564C16.9026 5.22362 16.7764 5.09739 16.6244 5.00962L13.3756 3.13397C13.2236 3.04621 13.0512 3 12.8756 3H9.12436ZM8.11775 2.17514C8.46284 2.26761 8.83105 2.16895 9.08367 1.91633L10.2929 0.707106C10.6834 0.316582 11.3166 0.316583 11.7071 0.707107L12.9163 1.91633C13.169 2.16895 13.5372 2.26761 13.8823 2.17514L15.5341 1.73254C16.0675 1.5896 16.6159 1.90618 16.7588 2.43965L17.2014 4.09147C17.2939 4.43656 17.5634 4.70611 17.9085 4.79858L19.5604 5.24118C20.0938 5.38412 20.4104 5.93246 20.2675 6.46593L19.8249 8.11775C19.7324 8.46284 19.831 8.83105 20.0837 9.08367L21.2929 10.2929C21.6834 10.6834 21.6834 11.3166 21.2929 11.7071L20.0837 12.9163C19.831 13.169 19.7324 13.5372 19.8249 13.8823L20.2675 15.5341C20.4104 16.0675 20.0938 16.6159 19.5604 16.7588L17.9085 17.2014C17.5634 17.2939 17.2939 17.5634 17.2014 17.9085L16.7588 19.5604C16.6159 20.0938 16.0675 20.4104 15.5341 20.2675L13.8823 19.8249C13.5372 19.7324 13.169 19.831 12.9163 20.0837L11.7071 21.2929C11.3166 21.6834 10.6834 21.6834 10.2929 21.2929L9.08367 20.0837C8.83105 19.831 8.46284 19.7324 8.11775 19.8249L6.46593 20.2675C5.93246 20.4104 5.38412 20.0938 5.24118 19.5604L4.79858 17.9085C4.70611 17.5634 4.43656 17.2939 4.09147 17.2014L2.43965 16.7588C1.90618 16.6159 1.5896 16.0675 1.73254 15.5341L2.17514 13.8823C2.26761 13.5372 2.16895 13.169 1.91633 12.9163L0.707106 11.7071C0.316582 11.3166 0.316583 10.6834 0.707107 10.2929L1.91633 9.08367C2.16895 8.83105 2.26761 8.46284 2.17514 8.11775L1.73254 6.46593C1.5896 5.93246 1.90618 5.38412 2.43965 5.24118L4.09147 4.79858C4.43656 4.70611 4.70611 4.43656 4.79858 4.09147L5.24118 2.43965C5.38412 1.90618 5.93246 1.5896 6.46593 1.73254L8.11775 2.17514Z"
            fill="#00AED9"
          />
          <path
            id="Star"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9995 12.9878L8.6484 14.2361L9.10903 11.6143L7.19531 9.76393L9.83114 9.39184L10.9995 7L12.1679 9.39184L14.8038 9.76393L12.89 11.6143L13.3507 14.2361L10.9995 12.9878Z"
            stroke="#00AED9"
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
));

export default GiveawayIcon;
